import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["form", "inputCategory", "inputDocumentType"];

  selectCategory(event) {
    if (!this.hasInputCategoryTarget) return;
    const value = event.currentTarget.dataset.text;
    const selectedCategories = this.inputCategoryTarget.value.split(",").filter(Boolean);
    const isSelected = selectedCategories.includes(value);
    let nextCategories;

    if (isSelected) {
      nextCategories = selectedCategories.filter(category => category !== value);
    } else {
      nextCategories = selectedCategories.concat(value);
    }

    this.inputCategoryTarget.value = nextCategories.join(",")
    this.updateCategoryButtons(nextCategories);
    this.refreshConseils();
  }

  selectDocument(event) {
    if (!this.hasInputDocumentTypeTarget) return;
    const value = event.currentTarget.dataset.text;
    const selectedDocumentTypes = this.inputDocumentTypeTarget.value.split(",").filter(Boolean);

    event.currentTarget.classList.toggle("selected")
    event.currentTarget.querySelector(".cross-criteria").classList.toggle("display-inline")

    if (selectedDocumentTypes.includes(value)) {
      this.inputDocumentTypeTarget.value = selectedDocumentTypes.filter(documentType => documentType !== value).join(",")
    } else {
      this.inputDocumentTypeTarget.value = selectedDocumentTypes.concat(value).join(",")
    }
    this.refreshConseils();
  }

  refreshConseils() {
    const category = this.hasInputCategoryTarget ? this.inputCategoryTarget.value : ""
    const documentType = this.hasInputDocumentTypeTarget ? this.inputDocumentTypeTarget.value : ""
    const params = new URLSearchParams({ category_list: category, document_type: documentType });

    fetch(`${this.formTarget.action}?${params.toString()}`, {headers: { Accept: "text/plain" }})
      .then(response => response.text())
      .then((data) => {
        document.querySelector("#main-index-conseils").outerHTML = data;
      })
    window.scrollTo(0, 0);
  }

  updateCategoryButtons(selectedCategories) {
    this.element.querySelectorAll('[data-action*="selectCategory"]').forEach((button) => {
      const selected = selectedCategories.includes(button.dataset.text);

      button.classList.toggle("selected", selected);
      button.querySelector(".cross-criteria").classList.toggle("display-inline", selected);
    })
  }
}
